import { ComponentProps, useEffect, useRef } from 'react'
import DayJS from '../../helpers/DayJS'

import { AssignationBar } from './AssignationBar'
import { Icon } from '../Icon'
import { setNewAccessToken } from '../../infrastructure/apis'
import { useIntercom } from '../../hooks/useIntercom'
import { useNavigate } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { useToken } from '../../hooks/useToken'

export const GoToCourseButton = ({
    courseId,
    slug,
    profileId,
    requirePayment,
    status,
    start,
    isInside,
    ...rest
}: ComponentProps<typeof AssignationBar>) => {
    const { t } = useTranslation('dashboard')
    const { _id } = useToken()
    const { chatWithSupport } = useIntercom()
    const navigate = useNavigate()
    const queryClient = useQueryClient()
    const lastInvalidatedStart = useRef<string | null>(null)

    // Invalidate queries when course starts (transition from enrolled to studying)
    useEffect(() => {
        const interval = setInterval(() => {
            if (isInside || status !== 'enrolled') return

            const now = DayJS()
            const startDate = DayJS(start)
            const startKey = start?.toString() ?? ''

            if (now.isAfter(startDate) && lastInvalidatedStart.current !== startKey) {
                lastInvalidatedStart.current = startKey
                queryClient.invalidateQueries({ queryKey: ['User', _id ?? 'Unknown', 'Courses'] })
            }
        }, 1000)
        return () => clearInterval(interval)
    }, [_id, isInside, queryClient, start, status])

    if (isInside) return null

    const goToCourse = () => {
        if (requirePayment) return chatWithSupport('')
        setNewAccessToken(rest['access-token'])
        const url = `/${slug ?? courseId}${profileId ? `?profileId=${profileId}` : ''}`
        navigate(url)
    }

    const getLabel = () => {
        if (status === 'finished') return t('Review content')
        if (requirePayment) return t('Secure my spot')
        return t('Content')
    }

    return (
        <button className="icon custom-button" onClick={goToCourse}>
            <Icon icon={['fas', 'folder']} size="lg" /> {getLabel()}
        </button>
    )
}
